var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-wrapper eDetails",staticStyle:{"border-top":"none","width":"100%"}},[_c('router-view',{staticClass:"h-100 d-flex align-content-between flex-wrap"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }